import React, { Component } from 'react';
import { Input, Button } from 'antd';

const { TextArea } = Input;

class MessageBoard extends Component {
    state = {
        data: [],
        content: '',
    }

    handleTextAreaChange = (e) => {
        this.setState({ content: e.target.value });
    }

    handleAdd = () => {
        const { content, data } = this.state;
        data.push({
            userName: '王丽芬',
            curEmployeeCode: '200003',
            time: '2020-11-16 09:44:00',
            content,
        });
        this.setState({
            data,
            content: '',
        });
    }

    handleDelete = (index) => {
        const { data } = this.state;
        data.splice(index, 1);
        this.setState({ data });
    }

    getMessageLIst = () => {
        const { data } = this.state;
        return (data || []).map((item, index) => {
            const { userName, curEmployeeCode, time, content } = item;
            return (
                <li key={index} className="message_item">
                    <div className="message_itemHead">
                        <span className="message_itemHead__user">
                            {userName}[{curEmployeeCode}]
                        </span>
                        <span className="message_itemHead__time">
                            {time}
                        </span>
                        <span className="message_itemHead__delete" onClick={() => this.handleDelete(index)}>×</span>
                    </div>
                    <div className="message_itemContent">
                        {content}
                    </div>
                </li>
            );
        });
    }

    render() {
        const { content } = this.state;
        return (
            <div className="message">
                <div className="message_close" onClick={this.props.toggleMessageBoardDisplay}>×</div>
                <div className="message_contain">
                    <ul className="message_list">
                        {this.getMessageLIst()}
                    </ul>
                </div>
                <div className="message_leave">
                    <TextArea
                        value={content}
                        style={{ width: 218, height: 70 }}
                        placeholder="请输入留言"
                        onChange={this.handleTextAreaChange}
                    />
                    <Button type="primary" style={{ marginLeft: 10 }} onClick={this.handleAdd}>留言</Button>
                </div>
            </div>
        );
    }
}

export default MessageBoard;


// WEBPACK FOOTER //
// ./src/components/quotation/Sidebar/Components/MessageBoard.js